import { cn } from "~/common/cn"
import { AppText } from "~/ui/app-text"
import { useEffect, useRef, useState } from "react"

export const RoomContentCardDescription = ({
  description,
  compact,
  onExpandChange,
  isExpanded,
  className,
}: {
  description: string
  compact: boolean
  isExpanded: boolean
  onExpandChange?: (expanded: boolean) => void
  className?: string
}) => {
  const [hasOverflow, setHasOverflow] = useState(false)
  const textRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current
      setHasOverflow(element.scrollHeight > element.clientHeight)
    }
  }, [description, compact])

  const toggleExpand = () => {
    onExpandChange?.(!isExpanded)
  }

  return (
    <div
      className={cn("flex flex-col text-center", className)}
      onClick={hasOverflow && !compact ? toggleExpand : undefined}
    >
      <AppText
        variant={compact ? "body3-medium" : "body2-medium"}
        className={cn(
          "overflow-hidden text-base-white md:text-[18px] md:leading-[23px]",
          !isExpanded && "line-clamp-2"
        )}
        ref={textRef}
      >
        {description}
      </AppText>
    </div>
  )
}
